import { SxProps } from '@mui/material'
import { COLORS } from '@/styles'
import { calc } from '@/utils'

export interface SummarySidebarStyles {
  wrapper: SxProps
  summaryCard: SxProps
  addOnCard: SxProps
  bookWrapper: SxProps
  bookHeading: SxProps
  bookDesc: SxProps
  addOnTitle: SxProps
  addOnDescriptionFull: SxProps
  addonsQuantityText: SxProps
  addonsQuantity: SxProps
  tickets: SxProps
  numberOfRooms: SxProps
  pinIcon: SxProps
  detailsCard: SxProps
  locationWrapper: SxProps
  checkIn: SxProps
  checkInWrapper: SxProps
  checkInDetailsWrapper: SxProps
  dashLine: SxProps
  checkInDate: SxProps
  calendarWrapper: SxProps
  flight: {
    airFare: SxProps
    airlineDetailsText: SxProps
    flightTitle: SxProps
    flightDetailsWrapper: SxProps
    flightInfoDivider: SxProps
    flightInfoWrapper: SxProps
  }
  hideInMobile: SxProps
}

const dimensions = {
  hotelIconSize: 16,
}
export const summarySidebarStyles: SummarySidebarStyles = {
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: 5,
  },
  summaryCard: {
    py: 3,
    px: 2.5,
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
    border: '1px solid',
    borderColor: 'border.secondary',
    borderRadius: 4,
    boxShadow: '0px 1px 2px 0px rgba(10, 13, 18, 0.05)',
  },
  bookWrapper: {
    px: 2.5,
  },
  bookHeading: { typography: 'textMdSemibold', color: 'text.primary', mb: 1 },
  bookDesc: {
    typography: 'textSm',
    color: 'text.primary',
    width: calc(dimensions.hotelIconSize),
    textTransform: 'capitalize',
  },
  addOnCard: {
    p: 2.5,
    display: 'flex',
    flexDirection: 'column',
    gap: 1.5,
    border: '1px solid',
    borderColor: 'border.secondary',
    borderRadius: 4,
    boxShadow: '0px 1px 2px 0px rgba(10, 13, 18, 0.05)',
  },
  addOnTitle: {
    typography: 'textMdSemibold',
    color: 'text.primary',
    mb: 0.5,
  },
  tickets: {
    typography: 'textXs',
    color: 'text.primary',
    textTransform: 'capitalize',
  },
  numberOfRooms: {
    fontSize: 'inherit',
    textTransform: 'lowercase',
  },
  addOnDescriptionFull: {
    typography: 'textXs',
    color: 'text.secondary700',
    mb: 1,
  },
  addonsQuantityText: { typography: 'textSmSemibold', color: 'text.primary' },
  addonsQuantity: { typography: 'textSmSemibold', color: 'text.secondary700', pl: 0.5 },
  detailsCard: { display: 'flex', flexDirection: 'column', gap: 1.5 },
  pinIcon: {
    color: COLORS.FOREGROUND_DISABLED,
    width: dimensions.hotelIconSize,
    display: 'flex',
    alignItems: 'center',
  },
  locationWrapper: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    gap: '2px',
    mt: 1.5,
  },
  checkIn: {
    typography: 'textSmMedium',
    color: 'text.primary',
  },
  checkInWrapper: {
    display: 'flex',
    alignItems: 'center',
    mt: 0.5,
  },
  checkInDetailsWrapper: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  dashLine: {
    typography: 'textXs',
    color: 'text.primary',
    mx: 1,
  },
  checkInDate: {
    typography: 'textSm',
    color: 'text.primary',
    display: 'flex',
    ml: 0.5,
  },
  calendarWrapper: {
    color: COLORS.FOREGROUND_DISABLED,
    width: dimensions.hotelIconSize,
    display: 'flex',
    alignItems: 'center',
    mr: 0.5,
  },
  flight: {
    airFare: {
      typography: 'textLgSemibold',
      color: 'text.primary',
    },
    airlineDetailsText: { typography: 'textXs', color: 'text.secondary700', display: 'flex' },
    flightTitle: {
      typography: 'textSmSemibold',
      color: 'text.primary',
    },
    flightDetailsWrapper: {},
    flightInfoDivider: {
      height: '1px',
      backgroundColor: 'button.borderDisabled',
      width: '100%',
    },
    flightInfoWrapper: {
      gap: 1.5,
    },
  },
  hideInMobile: {
    display: { xs: 'none', md: 'flex' },
  },
}
